import React from 'react';
import {NeuroMessage, AnswersList, RenderOnlyFor} from '@ignitesales/neuro-application';
import BasicFooter from "../../../../../../../shared/js/core-components/BasicFooter.jsx";
import ModernProduct from "../ModernProduct.jsx";
import {SummaryPageSubtitle, SummaryPageTitle} from "../../../../../../../shared/js/core-components/ProductPageMessages";
import ContactShareButtons from "../../../../../../../shared/js/core-components/ContactShareButtons";
import DialogueProductWrapper from "../../../../../../../shared/js/core-components/DialogueProductWrapper";
import ReturnToSurveyButton from "../../../../../../../shared/js/core-components/ReturnToSurveyButton";
import ActionButtonContainer from "../../../../../../../shared/js/core-components/ActionButtonContainer";

function SummaryPage({ componentClass, productsList }) {

    return (
        <div className={componentClass} id={componentClass}>
            <div className="container">
                <div className={`${componentClass}__section header-section`}>
                    <div className="header-section__blurb">
                        <NeuroMessage id="summary.subtitle" tagName="h6" />
                        <h2 className={`${componentClass}__section-title`}><SummaryPageTitle tagName={null} /></h2>
                        <RenderOnlyFor forSummaryPage={true}>
                            <p className={`${componentClass}__section-subtext`}><SummaryPageSubtitle tagName={null} /></p>
                        </RenderOnlyFor>
                    </div>
                    <div className="header-section__buttons">
                        <RenderOnlyFor forSummaryPage={true}>
                            <ContactShareButtons isLeftAligned={true} />
                            <ActionButtonContainer position="top" page="SummaryPage"></ActionButtonContainer>
                        </RenderOnlyFor>
                        <RenderOnlyFor forDetailsPage={true}>
                            <ActionButtonContainer position="top" page="DetailsPage"></ActionButtonContainer>
                        </RenderOnlyFor>
                    </div>
                </div>

                <div className={`${componentClass}__section`}>
                    <div className={`${componentClass}__products`}>
                        { productsList.map(p => <DialogueProductWrapper ProductComponent={ModernProduct} key={ p.id } product={p} />) }
                    </div>
                </div>
            </div>

            <div className={`${componentClass}__actions`}>
                <RenderOnlyFor forSummaryPage={true}>
                    <ActionButtonContainer position="bottom" page="SummaryPage"></ActionButtonContainer>
                </RenderOnlyFor>
                <RenderOnlyFor forDetailsPage={true}>
                    <ActionButtonContainer position="bottom" page="DetailsPage"></ActionButtonContainer>
                </RenderOnlyFor>
            </div>

            <div className={`${componentClass}__answers`}>
                <div className="container">
                    <h2 className={`${componentClass}__section-title`}><NeuroMessage id="answers.title"/></h2>
                    <p className={`${componentClass}__section-subtext`}><NeuroMessage id="answers.subtext"/></p>
                    <AnswersList linkToQuestion />
                    <ReturnToSurveyButton className={`${componentClass}__navigation`} />
                </div>
            </div>
            <BasicFooter/>
        </div>
    );
}

export default SummaryPage;

